import 'assets/css/components/ProgressBar.scss';

type ProgressBarProps = {
  pixels: number,
  maxPixels: number,
  minSuccessPixels: number,
  maxSuccessPixels: number,
};

const ProgressBar = ({ pixels, maxPixels, minSuccessPixels, maxSuccessPixels }: ProgressBarProps): JSX.Element => {
  const filledPercentage: number = (pixels / maxPixels) * 100;
  const status_value: string = (pixels >= minSuccessPixels && pixels <= maxSuccessPixels) ? 'success' : 'error';

  return (
    <div className="progress-bar-holder">
      <div
        className='progress-bar'
        data-status={ status_value }
        style={ {
          width: `${filledPercentage}%`
        } }
      ></div>
    </div>
  );
}

export default ProgressBar;
